module.exports = __webpack_public_path__ + "static/media/hen.e8f71af2.gif";